import { addTableConfig } from "../../components/batchClassRoleConfiguration/redux/tables/TableConfigTable";
import { ReuseControl } from "../../components/reuse/ReuseControl";
import AcceleratorDoc from "../AcceleratorDoc";
import { ColumnMatcher, ColumnMatcherData } from "../ColumnMatcher";
import { ColumnConfig } from "../config/ColumnConfig";
import DocTypeConfig from "../config/DocTypeConfig";
import { TableConfig } from "../config/TableConfig";
import ExtractedCell from "../ExtractedCell";
import { ExtractedTable } from "../ExtractedTable";
import Model from "../Model";
import { TableModel, TableModelData } from "../TableModel";
import { ExtractedTableData } from "./ExtractedTableData";

export { updateExtractionResultsFromTableModel, removeBadReuseTableModels };

function updateExtractionResultsFromTableModel(
  acceleratorDoc: AcceleratorDoc,
  docTypeConfig: DocTypeConfig,
  model: Model,
) {
  const tables = docTypeConfig.tables;
  const tablesForDocType = acceleratorDoc.tables.get(docTypeConfig.typeName)!;
  tables.forEach((table) => {
    const tableName = table.name;
    if (!tablesForDocType.has(tableName)) return;
    // figure out what the default
    const extractedTableData = tablesForDocType.get(tableName)!;
    const extracted = extractedTableData.getExtracted();
    const tableModel = model.getTableModel(tableName);
    if (!tableModel) {
      console.warn("ExtractedTable existed for TableModel that did not exist");
      return;
    }
    if (!extracted) {
      console.warn("TableModel existed for ExtractedTable that did not exist");
      // FIXME: insert EMPTY table if start pattern is empty
      extractedTableData.setExtracted(
        ExtractedTable.createTest({
          name: tableName,
          status:
            tableModel.isConfigured() && !tableModel.allowEmpty
              ? "ERROR"
              : "EMPTY",
          tableTemplateData: tableModel.toTableModelData(),
        }),
      );
      return;
    }
    // console.debug('ExtractedTable was already extracted by current TableModel');
    // } else {
    if (!extracted.extractedBy(tableModel)) {
      console.debug(
        `Update TBL:${table} TableModel from extracted ExtractedTable`,
      );
      // FIXME: update ExractedTable to be extracted by table model
      extracted.tableTemplateData = tableModel.toTableModelData();
      extracted.tableModelId = tableModel.getModelId();
      console.debug(
        `Updated table ${extracted.name} to use table model id ${extracted.tableModelId}`,
      );
    }
  });
}

function removeBadReuseTableModels(
  acceleratorDoc: AcceleratorDoc,
  docTypeConfig: DocTypeConfig,
  model: Model,
) {
  const tables = docTypeConfig.tables;
  tables.forEach((table) => {
    const extractedTableData = acceleratorDoc.getExtractedTableData(table);
    if (extractedTableData) {
      removeTableReuseModel(extractedTableData, table, model);
    }
  });
}

function removeTableReuseModel(
  extractedTableData: ExtractedTableData,
  table: TableConfig,
  model: Model,
) {
  console.log(
    `Removing table reuse models for ${extractedTableData.getName()} with model ${model.getName()} with ${extractedTableData.getReuse().length} reuse models`,
  );
  for (const reuseModelData of extractedTableData.getReuse()) {
    if (!reuseModelData) {
      console.log(`Not remove reuse model undefined`);
      continue;
    }
    // const newColumns = addTableModelMissingColumns(reuseModel, table.columnNames)
    // fix up model
    if (isTableModelMissingColumns(reuseModelData, table.columnNames)) {
      console.log(`ReuseModel ${reuseModelData} is missing columns`);
      // backup table model
      const reuseModel = new TableModel(reuseModelData);
      // get new columns to add later
      const newReuseModelColumns = addTableModelMissingColumns(
        reuseModelData,
        table.columnNames,
      );
      // geet
      const reuseTable = extractedTableData.fromCache(reuseModel)!;
      if (reuseTable != undefined) {
        console.log(
          `ReuseModel ${reuseModelData} has extraction reuse to update`,
        );
        let addedCells = 0;
        for (const row of reuseTable.rows) {
          const missingCells = table.columnNames.filter(
            (x) =>
              row.cells.find((cell) => cell.fieldName === x.fieldName) ==
              undefined,
          );
          if (missingCells.length > 0) {
            row.cells.push(
              ...missingCells.map((x) =>
                ExtractedCell.createTest({
                  fieldName: x.fieldName,
                }),
              ),
            );
            addedCells += missingCells.length;
          }
        }
        console.debug(`Added ${addedCells} cells to table ${table.name}`);
        newReuseModelColumns.forEach((x) =>
          reuseModel.updateColumn(new ColumnMatcher(x)),
        );
        reuseTable.tableModelId = reuseModel.getModelId();
        reuseTable.tableTemplateData = reuseModel.toTableModelData();
      }
      console.debug("Adding columns to reuse model");
      reuseModelData.columns.push(...newReuseModelColumns);
    }
  }
}

function isTableModelMissingColumns(
  table: TableModelData<any> | TableModel,
  columns: ColumnConfig[],
): boolean {
  console.log(
    `comparing tablemodel with ${table.columns.length} columns and ${columns.length} config columns`,
  );
  if (columns.length !== table.columns.length) {
    return true;
  }
  return !table.columns.every((x) =>
    table.columns.find((c) => c.columnName === x.columnName),
  );
}
function addTableModelMissingColumns(
  table: TableModelData<any> | TableModel,
  columns: ColumnConfig[],
): ColumnMatcherData[] {
  const missingCells = columns.filter(
    (x) =>
      table.columns.find((column) => column.columnName === x.fieldName) ==
      undefined,
  );
  return missingCells.map((x) => ColumnMatcher.createFromConfig(x));
}
